import { render, staticRenderFns } from "./CommentForm.vue?vue&type=template&id=625b1219&scoped=true&lang=pug&"
import script from "./CommentForm.vue?vue&type=script&lang=js&"
export * from "./CommentForm.vue?vue&type=script&lang=js&"
import style0 from "./CommentForm.vue?vue&type=style&index=0&id=625b1219&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625b1219",
  null
  
)

export default component.exports